import {isEqual} from 'lodash';
import {refreshRankingPage} from '@js/modules/public/rankings/institutional/view/helpers';

export function initRankingFiltersListeners() {
    const $multipleSelects = $('select.multiple-select');
    const $singleSelects = $('.ranking-filters select').not($('#modal-filter-form select'))
        .not($multipleSelects);
    const $modalFiltersForm = $('#modal-filter-form');
    $('.ranking-filters').not($modalFiltersForm)
        .on('keypress', '.ranking-filters [name="name"]', function (e) {
            if (e.which === 13) {
                refreshRankingPage();
            }
        })
        .on('change', '[name="countries_union"]', () => {
            const $countrySelect = $('#countries');
            $countrySelect.selectpicker('val', []);
            refreshRankingPage();
        })
        .on('change', '[name="mode"]', refreshRankingPage);

    $singleSelects
        .on('change', refreshRankingPage);

    initMultipleSelectRankingFilterListener($multipleSelects);

    $modalFiltersForm
        .on('click', '#btnFilter', () => {
            refreshRankingPage(false);
        });
}

export function toggleRankingFilters() {
    const $toggleFiltersSpan = $(this)
        .find('.btn-text');
    const $filtersContainer = $('.ranking-filters');
    if ($filtersContainer.hasClass('open')) {
        $filtersContainer.removeClass('open');
        $toggleFiltersSpan.text('Показать фильтры');
    } else {
        $filtersContainer.addClass('open');
        $toggleFiltersSpan.text('Скрыть фильтры');
    }
}

function createApplyButtonWrapper() {
    return `<div class="apply-multiple-select">
        <button type="button" class="btn btn-xs btn-default apply-multiple-select__btn">
            Применить фильтр
        </button>
    </div>`;
}

export function initMultipleSelectRankingFilterListener($multipleSelects) {
    if ($multipleSelects.length) {
        const initialSelectedValues = {};
        $multipleSelects.each(function () {
            const $select = $(this);
            const id = $select.attr('id');
            initialSelectedValues[id] = $select.val();
        });
        let isRefreshPageStarted = false;
        $multipleSelects
            .on('hidden.bs.select', function () {
                const $select = $(this);
                const id = $select.attr('id');
                $select.css('overflow', 'inherit');
                if (!isEqual(initialSelectedValues[id], $select.val()) && !isRefreshPageStarted) {
                    const $form = $select.closest('.ranking-filters');
                    if ($form.attr('id') !== 'modal-filter-form') {
                        refreshRankingPage();
                    }
                    isRefreshPageStarted = true;
                }
            })
            .on('changed.bs.select', (e) => {
                const $select = $(e.currentTarget);
                const $selectDropdown = $select.closest('.sidebar__filter')
                    .find('.dropdown-menu.open');
                $selectDropdown.css('overflow', 'inherit');
            })
            .on('loaded.bs.select', function () {
                const $select = $(this);
                const $selectDropdown = $select.closest('.sidebar__filter')
                    .find('.dropdown-menu.open');
                const $applyButtonWrapper = createApplyButtonWrapper();
                $selectDropdown.prepend($applyButtonWrapper);
                $selectDropdown
                    .on('click', '.apply-multiple-select__btn', function () {
                        const $btn = $(this);
                        const $form = $btn.closest('.ranking-filters');
                        if ($form.attr('id') !== 'modal-filter-form') {
                            refreshRankingPage();
                        }
                        isRefreshPageStarted = true;
                    });
            });
    }
}
